module.exports = __webpack_public_path__ + "img/26anos.17ecaf1e.svg";